export default "__VITE_ASSET__Cl__0fqk__"